'use strict';

function MoneyUpDashboardHomeSpend() {
  var _this = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_CardBankController, _MoneyUpDashboardHomeBase];

  this.presenter = null;
  this.analytics = null;
  this.onComplete = function () {};

  this.init = function () {
    this._super();
    $.when(this.presenter._contentLoadedPromise).then(this._setState.bind(this));
  };

  this.initAllReady = function () {
    this._super();
    this.initPage();
  };

  this.initPage = function () {
    var cellSettings = {
      product: 'MogoSpend',
      contentExtensions: {
        inactive: 'Discontinued'
      }
    };

    this._createProductCell(cellSettings);
    this.onComplete(); // tell page component is loaded
  };

  this._setState = function () {
    if (!_this.node.querySelector('.js--dashboard-product').mogo().create) {
      _this._productCell = _this._getProductCell();
      var productState = 'loading';
      var analyticsState = 'Loading';

      productState = 'inactive';
      analyticsState = 'Inactive';

      _this._productCell.setState(productState, analyticsState);
      // no scenarios for when an alert occurs
    }
  };

  this.destroy = function () {
    this._super();
  };
}